module.exports = __webpack_public_path__ + "assets/15.jpg?7432224f7c72d894b11c94099784aa7f";